import { useQuery } from '@tanstack/react-query';
import insurancesApi from '@/features/dashboard/insurances/api/insurancesApi.ts';
import { insurancesApiQueryKeys } from '@/features/dashboard/insurances/api/insurancesApi.queryKeys.ts';

const useGetInsurances = () => {
  return useQuery({
    queryKey: insurancesApiQueryKeys.list(),
    queryFn: () => insurancesApi.getList(),
    staleTime: 1000 * 60,
  });
};

export default useGetInsurances;
